import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/lib/i18n";
import { CatalogProvider } from "@/lib/catalog";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FinalCta, MobileStickyCta } from "@/components/Commercial";
import Home from "@/pages/Home";
import Modules from "@/pages/Modules";
import Sectors from "@/pages/Sectors";
import Pricing from "@/pages/Pricing";
import Demo from "@/pages/Demo";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Faq from "@/pages/Faq";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <LanguageProvider>
      <CatalogProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="flex min-h-screen flex-col">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/modules" element={<Modules />} />
                <Route path="/secteurs" element={<Sectors />} />
                <Route path="/tarifs" element={<Pricing />} />
                <Route path="/demo" element={<Demo />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/a-propos" element={<About />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/p/:slug" element={<LegalPage />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <FinalCta />
            <Footer />
            <MobileStickyCta />
          </div>
        </BrowserRouter>
      </CatalogProvider>
    </LanguageProvider>
  );
}
